import { commandDispatcher, queryExecutor } from '@/_core/cqrs';
import { Action } from '@/_core/fluxstore/types';
import { BoardActivityPanelState } from '../types';
import { useBoardActivityStore } from '../useModule';
import { useStorymapStore } from '../../../store';
import { UpdateLastSeenBoardActivityId } from '../../api/commands';
import { BoardActivityUnseenCountQuery } from '../../api/queries';
import type { BoardActivityUnseenCountResult } from '../../api/queries';

const { registerMiddleware, registerReducer } = useBoardActivityStore();

export class AcknowledgeBoardActivities extends Action<BoardActivityPanelState> {
    public static ACTION_TYPE = 'BoardActivity::AcknowledgeActivities';
    public _latestRelevantActivityId: string | null = null;

    constructor(
        public latestRelevantActivityId: string | null = null,
        public storymapId: string | null = null
    ) {
        super(AcknowledgeBoardActivities.ACTION_TYPE);
    }
}

const middleware = async (state: BoardActivityPanelState, action: AcknowledgeBoardActivities): Promise<boolean> => {
    const storymapStore = useStorymapStore();
    const storymapId = action.storymapId || storymapStore.state.id;
    if (!storymapId) {
        return false;
    }

    let latestRelevantActivityId = action.latestRelevantActivityId || state.latestRelevantActivityId;
    if (!latestRelevantActivityId) {
        const result = await queryExecutor.executeQuery<BoardActivityUnseenCountResult>(
            new BoardActivityUnseenCountQuery(storymapId)
        );
        latestRelevantActivityId = result?.LatestRelevantActivityId || null;
    }

    if (!latestRelevantActivityId) {
        return true;
    }

    action._latestRelevantActivityId = latestRelevantActivityId;
    await commandDispatcher.dispatchCommand(new UpdateLastSeenBoardActivityId(storymapId, latestRelevantActivityId));
    return true;
};

const reducer = (state: BoardActivityPanelState, action: AcknowledgeBoardActivities): void => {
    state.latestRelevantActivityId = action._latestRelevantActivityId || state.latestRelevantActivityId;
    if (!action.latestRelevantActivityId) {
        state.unseenCount = 0;
        state.realtimeCountedActivityIds = [];
    }
};

//@ts-ignore
registerMiddleware(AcknowledgeBoardActivities.ACTION_TYPE, middleware);
//@ts-ignore
registerReducer(AcknowledgeBoardActivities.ACTION_TYPE, reducer);
